"use strict";
/* eslint-disable no-unused-vars */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides a way to access commonly used namespaces
 *
 * Usage:
 *
 *   ```
 *   const $rdf = require('rdflib'); //or any other RDF/JS-compatible library
 *   const ns = require('solid-namespace')($rdf);
 *   const store = $rdf.graph();
 *
 *   let me = ...;
 *   let name = store.any(me, ns.vcard(‘fn’)) || store.any(me, ns.foaf(‘name’));
 *   ```
 * @module vocab
 */
var aliases;
(function (aliases) {
    aliases["acl"] = "http://www.w3.org/ns/auth/acl#";
    aliases["arg"] = "http://www.w3.org/ns/pim/arg#";
    aliases["as"] = "https://www.w3.org/ns/activitystreams#";
    aliases["cal"] = "http://www.w3.org/2002/12/cal/ical#";
    aliases["cert"] = "http://www.w3.org/ns/auth/cert#";
    aliases["contact"] = "http://www.w3.org/2000/10/swap/pim/contact#";
    aliases["dc"] = "http://purl.org/dc/elements/1.1/";
    aliases["dct"] = "http://purl.org/dc/terms/";
    aliases["doap"] = "http://usefulinc.com/ns/doap#";
    aliases["foaf"] = "http://xmlns.com/foaf/0.1/";
    aliases["http"] = "http://www.w3.org/2007/ont/http#";
    aliases["httph"] = "http://www.w3.org/2007/ont/httph#";
    aliases["icalTZ"] = "http://www.w3.org/2002/12/cal/icaltzd#";
    aliases["ldp"] = "http://www.w3.org/ns/ldp#";
    aliases["link"] = "http://www.w3.org/2007/ont/link#";
    aliases["log"] = "http://www.w3.org/2000/10/swap/log#";
    aliases["meeting"] = "http://www.w3.org/ns/pim/meeting#";
    aliases["mo"] = "http://purl.org/ontology/mo/";
    aliases["owl"] = "http://www.w3.org/2002/07/owl#";
    aliases["pad"] = "http://www.w3.org/ns/pim/pad#";
    aliases["patch"] = "http://www.w3.org/ns/pim/patch#";
    aliases["prov"] = "http://www.w3.org/ns/prov#";
    aliases["qu"] = "http://www.w3.org/2000/10/swap/pim/qif#";
    aliases["trip"] = "http://www.w3.org/ns/pim/trip#";
    aliases["rdf"] = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
    aliases["rdfs"] = "http://www.w3.org/2000/01/rdf-schema#";
    aliases["rss"] = "http://purl.org/rss/1.0/";
    aliases["sched"] = "http://www.w3.org/ns/pim/schedule#";
    aliases["schema"] = "http://schema.org/";
    aliases["sioc"] = "http://rdfs.org/sioc/ns#";
    aliases["solid"] = "http://www.w3.org/ns/solid/terms#";
    aliases["space"] = "http://www.w3.org/ns/pim/space#";
    aliases["stat"] = "http://www.w3.org/ns/posix/stat#";
    aliases["tab"] = "http://www.w3.org/2007/ont/link#";
    aliases["tabont"] = "http://www.w3.org/2007/ont/link#";
    aliases["ui"] = "http://www.w3.org/ns/ui#";
    aliases["vcard"] = "http://www.w3.org/2006/vcard/ns#";
    aliases["wf"] = "http://www.w3.org/2005/01/wf/flow#";
    aliases["xsd"] = "http://www.w3.org/2001/XMLSchema#";
    aliases["cco"] = "http://www.ontologyrepository.com/CommonCoreOntologies/";
    aliases["dbo"] = "http://dbpedia.org/ontology/";
    aliases["ex"] = "http://example.com/";
    aliases["tree"] = "https://w3id.org/tree#";
    aliases["ldes"] = "https://w3id.org/ldes#";
    aliases["st"] = "http://www.w3.org/ns/shapetrees#";
    aliases["hydra"] = "http://www.w3.org/ns/hydra/core#";
    aliases["void"] = "http://rdfs.org/ns/void#";
    aliases["shacl"] = "http://www.w3.org/ns/shacl#";
})(aliases || (aliases = {}));
/**
 * @param [rdflib] {RDF} Optional RDF Library (such as rdflib.js or rdf-ext) to inject
 */
var vocab = function (rdf) {
    if (rdf === void 0) { rdf = { namedNode: function (u) { return u; } }; }
    var namespaces = {};
    var _loop_1 = function (alias) {
        var expansion = aliases[alias];
        namespaces[alias] = function (localName) {
            if (localName === void 0) { localName = ''; }
            return rdf.namedNode(expansion + localName);
        };
    };
    for (var alias in aliases) {
        _loop_1(alias);
    }
    ;
    return namespaces;
};
var ns = vocab();
exports.default = ns;
//# sourceMappingURL=NameSpaces.js.map